export default __webpack_public_path__ + "static/media/Social_Youtube-1.1384f925.svg";